<template>
  <MGuidedCheckoutStep
    step-number="1"
    title="Wähle dein Grundpaket."
    :description="stepDescription"
  >
    <div
      class="m-gc-step-package__options"
      :class="{ 'm-gc-step-package__options--two': packageOptions.length === 2 }"
    >
      <button
        v-for="option in packageOptions"
        :key="option.id"
        type="button"
        class="m-gc-step-package__card"
        :class="{ 'm-gc-step-package__card--active': value === option.id }"
        @click="selectPreset(option.id)"
      >
        <strong>{{ option.label }}</strong>
        <p>{{ option.description }}</p>
      </button>
    </div>
  </MGuidedCheckoutStep>
</template>

<script>
import MGuidedCheckoutStep from 'theme/components/molecules/guided-checkout/m-guided-checkout-step'
import {
  applyPackagePreset,
  getPackagePresetOptions,
  isEinzelbodenEnabled
} from 'theme/helpers/guided-checkout'

export default {
  name: 'MGcStepPackage',
  components: {
    MGuidedCheckoutStep
  },
  props: {
    value: {
      type: String,
      default: 'standard'
    },
    product: {
      type: Object,
      required: true
    },
    bundleOptionsComponent: {
      type: Object,
      default: null
    }
  },
  computed: {
    packageOptions () {
      return getPackagePresetOptions()
    },
    stepDescription () {
      return isEinzelbodenEnabled()
        ? 'Einzelboden oder Komplettset — Leiste und Dämmung wählst du im Anschluss passend dazu.'
        : 'Jedes Set startet mit einer empfohlenen Leiste und Dämmung. Danach kannst du beides noch individuell anpassen.'
    }
  },
  mounted () {
    this.selectPreset(this.normalizePreset(this.value), false)
  },
  methods: {
    normalizePreset (preset) {
      const available = this.packageOptions.map(option => option.id)
      if (available.includes(preset)) return preset
      return available.includes('standard') ? 'standard' : (available[0] || 'standard')
    },
    selectPreset (preset, emit = true) {
      const nextPreset = this.normalizePreset(preset)
      applyPackagePreset(this.bundleOptionsComponent, this.product, nextPreset)

      if (emit) {
        this.$emit('input', nextPreset)
        this.$emit('changed')
      } else if (nextPreset !== this.value) {
        this.$emit('input', nextPreset)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.m-gc-step-package {
  &__options {
    display: grid;
    gap: 1rem;

    @media (min-width: 768px) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    &--two {
      @media (min-width: 768px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }
  }

  &__card {
    display: block;
    width: 100%;
    height: auto;
    min-height: 0;
    padding: 1rem;
    border: 1px solid var(--c-light);
    border-radius: 4px;
    background: var(--c-white);
    text-align: left;
    cursor: pointer;
    white-space: normal;
    overflow: hidden;
    transition: var(--gc-transition);

    strong {
      display: block;
      margin-bottom: 0.35rem;
      line-height: 1.3;
      font-weight: 700;
      white-space: normal;
    }

    p {
      margin: 0;
      color: var(--c-dark-variant);
      line-height: 1.4;
      font-weight: 400;
      white-space: normal;
    }

    &--active {
      border-color: var(--c-primary);
      box-shadow: 0 0 0 1px var(--c-primary);
    }
  }
}
</style>
